


import React from 'react'
import Offerte from './Offerte'

export default function OfferteContainer() {
    return (
        <div>
            <Offerte id={"1"} />
            <Offerte id={"2"} />
        </div>
    )
}
